let origin = window.ORIGIN;
//查询托幼课程
const getClassDataByDayUrl = `${origin}/gateway/hc-external/nursery/getClassDataByDay`;
//提交预约申请申请
const nurseryApplyUrl = `${origin}/gateway/hc-external/nursery/nurseryApply`;
//查询我的预约申请列表
const selectMyApplyUrl = `${origin}/gateway/hc-external/nursery/getUserApplyData`;
//托幼审核待审核数据
const getApplyDataUrl = `${origin}/gateway/hc-external/nursery/getApplyData`;
//审核申请
const handelStatusUrl = `${origin}/gateway/hc-external/nursery/doExamine`;
// 提交评价
const appraiseUrl = `${origin}/gateway/hc-external/nursery/appraise`;
// 获取上一次预约信息
const getLastOrderUrl = `${origin}/gateway/hc-external/nursery/getLastOrder`;
//查询是否有权限查看监控
const lookPower = `${origin}/gateway/hc-external/nursery/getVideoData`;

//审核申请
const judgeApplyUrl = `${origin}/gateway/hc-external/nursery/doExamine`;

export {
  getClassDataByDayUrl,
  lookPower,
  nurseryApplyUrl,
  // entrustChildUrl,
  handelStatusUrl,
  selectMyApplyUrl,
  getApplyDataUrl,
  judgeApplyUrl,
  appraiseUrl,
  getLastOrderUrl,
};
